import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { fetchCities } from "@/lib/api";
import { pickRandomPalette, paletteVars } from "@/lib/palettes";
import { useSeo } from "@/lib/seo";
import { ChevronDown, MapPin, Crown, ShieldCheck } from "lucide-react";

export default function Home() {
  const data = useMemo(() => fetchCities(), []);
  const [openSlug, setOpenSlug] = useState(null);
  const P = useMemo(() => pickRandomPalette(`home-${Date.now()}`), []);

  useSeo({
    path: "/",
    title: "Türkiye Escort, Türkiye Vip Escort Hizmeti, Gerçek ve Premium Escort İlanları, Sınırsız Eskort",
    description: `Türkiye genelinde ${data.total_cities} il ve ${data.total_districts} ilçede aktif gerçek ve onaylı premium escort ilanları. Vip kalite ve sınırsız hizmet anlayışıyla şehrinizdeki profilleri keşfedin.`,
  });

  return (
    <div className="np-home" data-testid="home-page" style={paletteVars(P)}>
      <header className="np-header" data-testid="home-header">
        <div className="np-brand">
          <span className="np-brand-deco">◆</span>
          <span className="np-brand-nova">NOVA</span>
          <span className="np-brand-amp">&amp;</span>
          <span className="np-brand-platinium">PLATİNİUM</span>
          <span className="np-brand-deco">◆</span>
        </div>
        <div className="np-brand-tagline">PREMİUM ESCORT SİTESİ</div>
      </header>

      {/* HERO — NOVA GROUP GURURLA SUNAR */}
      <section className="np-hero">
        <div className="np-hero-crown">
          <Crown size={18} strokeWidth={2.5} />
        </div>
        <div className="np-hero-presents" data-testid="hero-presents">
          <span className="np-hero-presents-line" />
          <span>NOVA GROUP GURURLA SUNAR</span>
          <span className="np-hero-presents-line" />
        </div>
        <h1 className="np-hero-h1" data-testid="home-h1">
          İLLERE GÖRE <span className="np-hero-accent">SİTE AĞIMIZ</span>
        </h1>
        <p className="np-hero-sub">
          {data.total_cities} il ve {data.total_districts}+ ilçeyi kapsayan Türkiye'nin en geniş premium escort sitesi ağı.
        </p>

        <div className="np-hero-stats">
          <div className="np-stat" data-testid="stat-cities">
            <span className="np-stat-num">{data.total_cities}</span>
            <span className="np-stat-label">İL</span>
          </div>
          <div className="np-stat-sep" />
          <div className="np-stat" data-testid="stat-districts">
            <span className="np-stat-num">{data.total_districts}+</span>
            <span className="np-stat-label">İLÇE</span>
          </div>
          <div className="np-stat-sep" />
          <div className="np-stat" data-testid="stat-active">
            <span className="np-stat-num">7/24</span>
            <span className="np-stat-label">AKTİF</span>
          </div>
        </div>

        <div className="np-hero-trust">
          <ShieldCheck size={14} strokeWidth={2.5} />
          <span>Tüm profiller kimlik doğrulamasından geçer</span>
        </div>
      </section>

      {/* CITIES — DÜZ LİSTE (alfabetik gruplama YOK, arama YOK) */}
      <main className="np-cities-wrap">
        <div className="np-cities">
          {data.cities.map((city) => {
            const isOpen = openSlug === city.slug;
            return (
              <div
                key={city.slug}
                className={`np-city ${isOpen ? "open" : ""}`}
                data-testid={`city-card-${city.slug}`}
              >
                <div
                  className="np-city-head"
                  onClick={() => setOpenSlug(isOpen ? null : city.slug)}
                >
                  <div className="np-city-name-wrap">
                    <MapPin size={14} strokeWidth={2.5} className="np-city-pin" />
                    <span className="np-city-il-label">{city.name.toLocaleUpperCase("tr-TR")} İLİMİZ</span>
                  </div>
                  <div className="np-city-meta">
                    <span className="np-city-count">{city.districts.length} ilçe</span>
                    <ChevronDown size={16} className="np-city-arrow" />
                  </div>
                </div>
                {isOpen && (
                  <div className="np-city-tree" data-testid={`city-tree-${city.slug}`}>
                    <Link
                      to={`/${city.slug}/escort`}
                      className="np-tree-item np-tree-il"
                      data-testid={`il-link-${city.slug}`}
                    >
                      <span className="np-tree-bullet">▸</span>
                      <span className="np-tree-name">{city.name} Escort</span>
                      <span className="np-tree-url">/{city.slug}/escort</span>
                    </Link>
                    {city.districts.map((d) => (
                      <Link
                        key={d.slug}
                        to={`/${city.slug}/${d.slug}/escort`}
                        className="np-tree-item"
                        data-testid={`ilce-link-${city.slug}-${d.slug}`}
                      >
                        <span className="np-tree-bullet">▸</span>
                        <span className="np-tree-name">{d.name} Escort</span>
                        <span className="np-tree-url">/{city.slug}/{d.slug}/escort</span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </main>

      <footer className="np-foot">
        <p>© {new Date().getFullYear()} NOVA &amp; PLATİNİUM · Premium Escort Sitesi</p>
      </footer>
    </div>
  );
}
